import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { query: String };

  connect() {
    if (this.skipIfWrongPath()) return;

    // Remember the last query used to render the current overview
    this.lastQuery = (this.hasQueryValue && this.queryValue ? this.queryValue : '').trim();

    this.attachSearchListeners();
    this.initHtmxLoadListener();

    window.refreshOverview = (query, options = {}) => {
      this.refreshOverview(query, options);
    };
  }

  // ActionCable now handles all show/hide logic for benchmate_chats
  initHtmxLoadListener() { }

  skipIfWrongPath() {
    return false; // No longer needed since we don't require the create chat URL
  }

  attachSearchListeners() {
    // Listen for search results being loaded, then refresh the chat overview
    window.addEventListener('search:loaded', (event) => {
      const searchForm = document.querySelector("#unified-search-form");
      if (searchForm) {
        const query = new FormData(searchForm).get("query");
        if (query && query.trim()) {
          this.refreshOverview(query);
        }
      }
    });
  }

  closeTypeahead() {
    const typeaheadMenu = document.querySelector(".tt-menu");
    if (typeaheadMenu && typeaheadMenu.classList.contains("tt-open")) {
      typeaheadMenu.classList.remove("tt-open");
      typeaheadMenu.style.display = "none";
    }
  }

  removeExistingOverview() {
    const existingContent = document.querySelector("#benchmate_chats");
    if (existingContent) {
      this.hideFadeOut(existingContent);
    }
  }

  showFadeIn(elt) {
    setTimeout(() => {
      elt.classList.remove("d-none");
    }, 500);
    elt.style.transition = "opacity 0.5s ease";
    // eslint-disable-next-line no-unused-expressions
    elt.offsetHeight;
    elt.classList.remove("opacity-0");
  }

  hideFadeOut(elt) {
    elt.classList.add("opacity-0");
    setTimeout(() => {
      elt.classList.add("d-none");
    }, 500);
  }

  refreshOverview(query, { responseOk = true } = {}) {
    const incoming = (query || '').trim();

    if (!incoming || (this.lastQuery && incoming.toLowerCase() === this.lastQuery.toLowerCase())) {
      return;
    }

    this.lastQuery = incoming;
  }
}
